export const siteConfig = {
  name: '好联系',
  tagline: '让每一次联系都更有价值',
  description: '好联系是专为职场人与创业者打造的人脉管理平台，帮助您高效整理联系人、智能跟进关系、挖掘潜在商机。告别杂乱通讯录，用好联系让每段关系都产生真实价值。',
  url: 'https://haolianxi.com',
};

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '人脉百科', href: '/category/knowledge' },
  { label: '行业洞察', href: '/category/insights' },
  { label: '案例分享', href: '/category/cases' },
  { label: '关于我们', href: '/about' },
];

export const footerLinks = {
  product: {
    title: '产品',
    links: [
      { label: '功能介绍', href: '/#features' },
      { label: '定价方案', href: '/#pricing' },
      { label: '更新日志', href: '/category/knowledge' },
      { label: '常见问题', href: '/#faq' },
    ],
  },
  resources: {
    title: '资源',
    links: [
      { label: '人脉百科', href: '/category/knowledge' },
      { label: '行业洞察', href: '/category/insights' },
      { label: '案例分享', href: '/category/cases' },
      { label: '使用指南', href: '/category/knowledge' },
    ],
  },
  company: {
    title: '公司',
    links: [
      { label: '关于我们', href: '/about' },
      { label: '品牌故事', href: '/about#story' },
      { label: '用户口碑', href: '/about#testimonials' },
      { label: '联系我们', href: '/about#contact' },
    ],
  },
  legal: {
    title: '法律',
    links: [
      { label: '隐私政策', href: '/category/knowledge' },
      { label: '服务条款', href: '/category/knowledge' },
      { label: 'Cookie 政策', href: '/category/knowledge' },
    ],
  },
};